"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.softDeletePerformanceTemporaryDelete = exports.softDeletePerformanceRestoreBulk = exports.softDeletePerformanceRestore = exports.softDeletePerformancePermanentlyDeleteBulk = exports.softDeletePerformancePermanentlyDelete = exports.softDeletePerformanceList = exports.softDeleteImpactTemporaryDelete = exports.softDeleteImpactRestoreBulk = exports.softDeleteImpactRestore = exports.softDeleteImpactPermanentlyDeleteBulk = exports.softDeleteImpactPermanentlyDelete = exports.softDeleteImpactList = exports.softDeleteDonorTemporaryDelete = exports.softDeleteDonorRestoreBulk = exports.softDeleteDonorRestore = exports.softDeleteDonorPermanentlyDeleteBulk = exports.softDeleteDonorPermanentlyDelete = exports.softDeleteDonorList = exports.softDeleteDetailTemporaryDelete = exports.softDeleteDetailRestoreBulk = exports.softDeleteDetailRestore = exports.softDeleteDetailPermanentlyDeleteBulk = exports.softDeleteDetailPermanentlyDelete = exports.softDeleteDetailList = exports.accessCriteriaForReportDataUpdatePerformance = exports.accessCriteriaForReportDataUpdateImpact = exports.accessCriteriaForReportDataUpdateDonor = exports.accessCriteriaForReportDataUpdate = exports.accessCriteriaForReportDataSuccess = exports.accessCriteriaForReportDataReset = exports.accessCriteriaForReportDataFetchPerformance = exports.accessCriteriaForReportDataFetchImpact = exports.accessCriteriaForReportDataFetchDonor = exports.accessCriteriaForReportDataFetch = exports.accessCriteriaForReportDataError = exports.accessCriteriaForReportDataAddPerformance = exports.accessCriteriaForReportDataAddImpact = exports.accessCriteriaForReportDataAddDonor = exports.accessCriteriaForReportDataAdd = void 0;
var _accessCriteriaForReportData = require("./accessCriteriaForReportData.constant");
// @flow

/**
 * Action creator for success action.
 * @param {string} actionType - The type of action.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 */
var accessCriteriaForReportDataSuccess = function accessCriteriaForReportDataSuccess(actionType, data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

/**
 * Action creator for error action.
 * @param {string} actionType - The type of action.
 * @param {any} error - The error payload.
 * @returns {Object} - The action object with type and payload.
 */
exports.accessCriteriaForReportDataSuccess = accessCriteriaForReportDataSuccess;
var accessCriteriaForReportDataError = function accessCriteriaForReportDataError(actionType, error) {
  return {
    type: _accessCriteriaForReportData.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * Action creator for fetch action.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to fetch data.
 */
exports.accessCriteriaForReportDataError = accessCriteriaForReportDataError;
var accessCriteriaForReportDataFetch = function accessCriteriaForReportDataFetch(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.FETCH,
    payload: data
  };
};

/**
 * Action creator for add action.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to add data.
 */
exports.accessCriteriaForReportDataFetch = accessCriteriaForReportDataFetch;
var accessCriteriaForReportDataAdd = function accessCriteriaForReportDataAdd(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.ADD,
    payload: data
  };
};

/**
 * Action creator for update action.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to update data.
 */
exports.accessCriteriaForReportDataAdd = accessCriteriaForReportDataAdd;
var accessCriteriaForReportDataUpdate = function accessCriteriaForReportDataUpdate(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.UPDATE,
    payload: data
  };
};

/**
 * Action creator for fetch donor action.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to fetch donor data.
 */
exports.accessCriteriaForReportDataUpdate = accessCriteriaForReportDataUpdate;
var accessCriteriaForReportDataFetchDonor = function accessCriteriaForReportDataFetchDonor(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.FETCH_DONOR,
    payload: data
  };
};

/**
 * Action creator for add donor action.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to add donor data.
 */
exports.accessCriteriaForReportDataFetchDonor = accessCriteriaForReportDataFetchDonor;
var accessCriteriaForReportDataAddDonor = function accessCriteriaForReportDataAddDonor(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.ADD_DONOR,
    payload: data
  };
};

/**
 * Action creator for update donor action.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to update donor data.
 */
exports.accessCriteriaForReportDataAddDonor = accessCriteriaForReportDataAddDonor;
var accessCriteriaForReportDataUpdateDonor = function accessCriteriaForReportDataUpdateDonor(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.UPDATE_DONOR,
    payload: data
  };
};

/**
 * Action creator for fetch performance action.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to fetch performance data.
 */
exports.accessCriteriaForReportDataUpdateDonor = accessCriteriaForReportDataUpdateDonor;
var accessCriteriaForReportDataFetchPerformance = function accessCriteriaForReportDataFetchPerformance(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.FETCH_PERFORMANCE,
    payload: data
  };
};

/**
 * Action creator for add performance action.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to add performance data.
 */
exports.accessCriteriaForReportDataFetchPerformance = accessCriteriaForReportDataFetchPerformance;
var accessCriteriaForReportDataAddPerformance = function accessCriteriaForReportDataAddPerformance(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.ADD_PERFORMANCE,
    payload: data
  };
};

/**
 * Action creator for update performance action.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to update performance data.
 */
exports.accessCriteriaForReportDataAddPerformance = accessCriteriaForReportDataAddPerformance;
var accessCriteriaForReportDataUpdatePerformance = function accessCriteriaForReportDataUpdatePerformance(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.UPDATE_PERFORMANCE,
    payload: data
  };
};

/**
 * Action creator for fetch impact action.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to fetch impact data.
 */
exports.accessCriteriaForReportDataUpdatePerformance = accessCriteriaForReportDataUpdatePerformance;
var accessCriteriaForReportDataFetchImpact = function accessCriteriaForReportDataFetchImpact(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.FETCH_IMPACT,
    payload: data
  };
};

/**
 * Action creator for add impact action.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to add impact data.
 */
exports.accessCriteriaForReportDataFetchImpact = accessCriteriaForReportDataFetchImpact;
var accessCriteriaForReportDataAddImpact = function accessCriteriaForReportDataAddImpact(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.ADD_IMPACT,
    payload: data
  };
};

/**
 * Action creator for update impact action.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to update impact data.
 */
exports.accessCriteriaForReportDataAddImpact = accessCriteriaForReportDataAddImpact;
var accessCriteriaForReportDataUpdateImpact = function accessCriteriaForReportDataUpdateImpact(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.UPDATE_IMPACT,
    payload: data
  };
};

/**
 * Action creator for reset action.
 * @returns {Object} - The action object with type.
 * @description This function is used to reset the item.
 */
exports.accessCriteriaForReportDataUpdateImpact = accessCriteriaForReportDataUpdateImpact;
var accessCriteriaForReportDataReset = function accessCriteriaForReportDataReset() {
  return {
    type: _accessCriteriaForReportData.actionTypes.RESET
  };
};

/**
 * Action creator for soft deleting detail data temporarily.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to temporarily delete detail data.
 */
exports.accessCriteriaForReportDataReset = accessCriteriaForReportDataReset;
var softDeleteDetailTemporaryDelete = function softDeleteDetailTemporaryDelete(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.SOFT_DELETE_DETAIL_TEMPORARY_DELETE,
    payload: data
  };
};

/**
 * Action creator for soft deleting detail data in list.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to soft delete detail data in list.
 */
exports.softDeleteDetailTemporaryDelete = softDeleteDetailTemporaryDelete;
var softDeleteDetailList = function softDeleteDetailList(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.SOFT_DELETE_DETAIL_LIST,
    payload: data
  };
};

/**
 * Action creator for permanently deleting detail data.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to permanently delete detail data.
 */
exports.softDeleteDetailList = softDeleteDetailList;
var softDeleteDetailPermanentlyDelete = function softDeleteDetailPermanentlyDelete(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.SOFT_DELETE_DETAIL_PERMANENTLY_DELETE,
    payload: data
  };
};

/**
 * Action creator for permanently deleting detail data in bulk.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to permanently delete detail data in bulk.
 */
exports.softDeleteDetailPermanentlyDelete = softDeleteDetailPermanentlyDelete;
var softDeleteDetailPermanentlyDeleteBulk = function softDeleteDetailPermanentlyDeleteBulk(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.SOFT_DELETE_DETAIL_PERMANENTLY_DELETE_BULK,
    payload: data
  };
};

/**
 * Action creator for restoring detail data from soft delete.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to restore detail data from soft delete.
 */
exports.softDeleteDetailPermanentlyDeleteBulk = softDeleteDetailPermanentlyDeleteBulk;
var softDeleteDetailRestore = function softDeleteDetailRestore(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.SOFT_DELETE_DETAIL_RESTORE,
    payload: data
  };
};

/**
 * Action creator for restoring detail data from soft delete in bulk.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to restore detail data from soft delete in bulk.
 */
exports.softDeleteDetailRestore = softDeleteDetailRestore;
var softDeleteDetailRestoreBulk = function softDeleteDetailRestoreBulk(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.SOFT_DELETE_DETAIL_RESTORE_BULK,
    payload: data
  };
};

/**
 * Action creator for temporarily deleting performance data.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to temporarily delete performance data.
 */
exports.softDeleteDetailRestoreBulk = softDeleteDetailRestoreBulk;
var softDeletePerformanceTemporaryDelete = function softDeletePerformanceTemporaryDelete(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.SOFT_DELETE_PERFORMANCE_TEMPORARY_DELETE,
    payload: data
  };
};

/**
 * Action creator for soft deleting performance data in list.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to soft delete performance data in list.
 */
exports.softDeletePerformanceTemporaryDelete = softDeletePerformanceTemporaryDelete;
var softDeletePerformanceList = function softDeletePerformanceList(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.SOFT_DELETE_PERFORMANCE_LIST,
    payload: data
  };
};

/**
 * Action creator for permanently deleting performance data.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to permanently delete performance data.
 */
exports.softDeletePerformanceList = softDeletePerformanceList;
var softDeletePerformancePermanentlyDelete = function softDeletePerformancePermanentlyDelete(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.SOFT_DELETE_PERFORMANCE_PERMANENTLY_DELETE,
    payload: data
  };
};

/**
 * Action creator for permanently deleting performance data in bulk.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to permanently delete performance data in bulk.
 */
exports.softDeletePerformancePermanentlyDelete = softDeletePerformancePermanentlyDelete;
var softDeletePerformancePermanentlyDeleteBulk = function softDeletePerformancePermanentlyDeleteBulk(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.SOFT_DELETE_PERFORMANCE_PERMANENTLY_DELETE_BULK,
    payload: data
  };
};

/**
 * Action creator for restoring performance data from soft delete.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to restore performance data from soft delete.
 */
exports.softDeletePerformancePermanentlyDeleteBulk = softDeletePerformancePermanentlyDeleteBulk;
var softDeletePerformanceRestore = function softDeletePerformanceRestore(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.SOFT_DELETE_PERFORMANCE_RESTORE,
    payload: data
  };
};

/**
 * Action creator for restoring performance data from soft delete in bulk.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to restore performance data from soft delete in bulk.
 */
exports.softDeletePerformanceRestore = softDeletePerformanceRestore;
var softDeletePerformanceRestoreBulk = function softDeletePerformanceRestoreBulk(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.SOFT_DELETE_PERFORMANCE_RESTORE_BULK,
    payload: data
  };
};

/**
 * Action creator for temporarily deleting donor data.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to temporarily delete donor data.
 */
exports.softDeletePerformanceRestoreBulk = softDeletePerformanceRestoreBulk;
var softDeleteDonorTemporaryDelete = function softDeleteDonorTemporaryDelete(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.SOFT_DELETE_DONOR_TEMPORARY_DELETE,
    payload: data
  };
};

/**
 * Action creator for soft deleting donor data in list.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to soft delete donor data in list.
 */
exports.softDeleteDonorTemporaryDelete = softDeleteDonorTemporaryDelete;
var softDeleteDonorList = function softDeleteDonorList(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.SOFT_DELETE_DONOR_LIST,
    payload: data
  };
};

/**
 * Action creator for permanently deleting donor data.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to permanently delete donor data.
 */
exports.softDeleteDonorList = softDeleteDonorList;
var softDeleteDonorPermanentlyDelete = function softDeleteDonorPermanentlyDelete(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.SOFT_DELETE_DONOR_PERMANENTLY_DELETE,
    payload: data
  };
};

/**
 * Action creator for permanently deleting donor data in bulk.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to permanently delete donor data in bulk.
 */
exports.softDeleteDonorPermanentlyDelete = softDeleteDonorPermanentlyDelete;
var softDeleteDonorPermanentlyDeleteBulk = function softDeleteDonorPermanentlyDeleteBulk(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.SOFT_DELETE_DONOR_PERMANENTLY_DELETE_BULK,
    payload: data
  };
};

/**
 * Action creator for restoring donor data from soft delete.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to restore donor data from soft delete.
 */
exports.softDeleteDonorPermanentlyDeleteBulk = softDeleteDonorPermanentlyDeleteBulk;
var softDeleteDonorRestore = function softDeleteDonorRestore(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.SOFT_DELETE_DONOR_RESTORE,
    payload: data
  };
};

/**
 * Action creator for restoring donor data from soft delete in bulk.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to restore donor data from soft delete in bulk.
 */
exports.softDeleteDonorRestore = softDeleteDonorRestore;
var softDeleteDonorRestoreBulk = function softDeleteDonorRestoreBulk(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.SOFT_DELETE_DONOR_RESTORE_BULK,
    payload: data
  };
};

/**
 * Action creator for temporarily deleting impact data.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to temporarily delete impact data.
 */
exports.softDeleteDonorRestoreBulk = softDeleteDonorRestoreBulk;
var softDeleteImpactTemporaryDelete = function softDeleteImpactTemporaryDelete(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.SOFT_DELETE_IMPACT_TEMPORARY_DELETE,
    payload: data
  };
};

/**
 * Action creator for soft deleting impact data in list.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to soft delete impact data in list.
 */
exports.softDeleteImpactTemporaryDelete = softDeleteImpactTemporaryDelete;
var softDeleteImpactList = function softDeleteImpactList(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.SOFT_DELETE_IMPACT_LIST,
    payload: data
  };
};

/**
 * Action creator for permanently deleting impact data.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to permanently delete impact data.
 */
exports.softDeleteImpactList = softDeleteImpactList;
var softDeleteImpactPermanentlyDelete = function softDeleteImpactPermanentlyDelete(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.SOFT_DELETE_IMPACT_PERMANENTLY_DELETE,
    payload: data
  };
};

/**
 * Action creator for permanently deleting impact data in bulk.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to permanently delete impact data in bulk.
 */
exports.softDeleteImpactPermanentlyDelete = softDeleteImpactPermanentlyDelete;
var softDeleteImpactPermanentlyDeleteBulk = function softDeleteImpactPermanentlyDeleteBulk(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.SOFT_DELETE_IMPACT_PERMANENTLY_DELETE_BULK,
    payload: data
  };
};

/**
 * Action creator for restoring impact data from soft delete.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to restore impact data from soft delete.
 */
exports.softDeleteImpactPermanentlyDeleteBulk = softDeleteImpactPermanentlyDeleteBulk;
var softDeleteImpactRestore = function softDeleteImpactRestore(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.SOFT_DELETE_IMPACT_RESTORE,
    payload: data
  };
};

/**
 * Action creator for restoring impact data from soft delete in bulk.
 * @param {any} data - The payload data.
 * @returns {Object} - The action object with type and payload.
 * @description This function is used to restore impact data from soft delete in bulk.
 */
exports.softDeleteImpactRestore = softDeleteImpactRestore;
var softDeleteImpactRestoreBulk = function softDeleteImpactRestoreBulk(data) {
  return {
    type: _accessCriteriaForReportData.actionTypes.SOFT_DELETE_IMPACT_RESTORE_BULK,
    payload: data
  };
};
exports.softDeleteImpactRestoreBulk = softDeleteImpactRestoreBulk;